import { GAME_ROAD_WIDTH } from '../../constants/AppConstants';

export default class Dasher extends Phaser.Group {
  constructor({ game, dir = 1, moveSpeed = 0, variations, rowInd, id, dasherType }) {
    super(game, 0, 0);

    this.game = game;

    this.variations = variations;

    this.game = game;
    this.dir = dir;
    this.rowInd = rowInd;
    this.id = id;
    this.dasherType = (dasherType + id) % 4;
    this.hasCharacter = false;

    this.trolley = this.game.make.spine(0, 0, 'trolley');
    this.trolleyAnim = this.trolley.setAnimationByName(0, 'run', true);
    this.trolley.anchor.set(0.5, 1);

    this.dasher = this.game.make.spine(0, 0, 'trolleyDashers');
    this.dasherAnim = this.dasher.setAnimationByName(0, 'run', true);
    this.dasher.anchor.set(0.5, 1);
    this.chooseRandomDasher();

    this.addChild(this.trolley);
    this.addChild(this.dasher);

    this.trolley.scale.x = this.dir;
    this.dasher.scale.x = this.dir;

    this.moveSpeed = moveSpeed;
  }

  get width() {
    return 200;
  }

  //Update the cars movement and check whether it's out of bounds
  move(timeStep) {
    let dx = this.moveSpeed * timeStep;
    this.position.x += dx * this.dir;
    this.checkOutOfBounds();
  }

  getWorldBounds() {
    let bounds = this.getBounds();

    // change width
    let w = bounds.width;
    let xc = bounds.x + w / 2; // center of rect
    bounds.width = 200;
    bounds.x = xc - bounds.width / 2 + 10;

    // change height
    let h = bounds.height;
    let y = bounds.y;
    let btm = y + h;
    bounds.height = 60;
    bounds.y = btm - bounds.height;

    // fix position
    bounds.x += this.game.camera.view.x;
    bounds.y += this.game.camera.view.y;

    return bounds;
  }

  stopAnimation() {
    this.trolleyAnim.timeScale = 0;
    this.dasherAnim.timeScale = 0;
  }

  startAnimation() {
    this.dasherAnim.timeScale = 1;
  }

  chooseRandomDasher() {
    // release character
    if (this.hasCharacter) {
      this.hasCharacter = false;
      this.game.controller.gameModel.isCharacterAvailable = true;
    }

    //
    const dasherSkins = ['burger', 'chip', 'falafel', 'hotdog'];
    //let randDasher = (this.rowInd + this.id + this.level) % 4; //this.game.rnd.integerInRange(0, this.variations - 1);
    this.dasher.setSkinByName(dasherSkins[this.dasherType]);

    // set trolley skin
    let trolleySkin = 'full_' + this.game.rnd.integerInRange(1, 7);
    // try to place character to trolley
    if (
      this.game.hero &&
      this.game.controller.gameModel.isCharacterAvailable &&
      (this.rowInd == this.game.hero.currentRow - 1 || this.rowInd == this.game.hero.currentRow + 1)
    ) {
      this.game.controller.gameModel.isCharacterAvailable = false;
      this.hasCharacter = true;
      trolleySkin = this.game.hero.character == 'apple' ? 'onion' : 'apple';

      // play audio
      //this.playGiggle();
    }
    //
    this.trolley.setSkinByName(trolleySkin);
  }

  /*
  playGiggle() {
    if (this.hasCharacter && this.game) {
      let delay = this.game.rnd.integerInRange(1000, 2000);
      let character = this.game.hero.character == 'apple' ? 'onion' : 'apple';
      this.game.sounds.playSFX('giggle_' + character, { delay: delay, onComplete: this.playGiggle, onCompleteScope: this });
    }
  }
  */

  getInnerVehicleBounds() {
    let bounds = [];
    bounds = this.game.controller.config.getVehicleBounds(this.vehicleType);
    let newBounds = [];

    bounds.forEach((element, indx) => {
      let x = element.x + this.position.x;
      newBounds.push({
        x: x,
        y: element.y + this.position.y,
        width: element.width,
        height: element.height,
        fixPosition: element.y + +this.position.y + element.fixPosition,
      });
    });

    if (this.dir === -1) {
      newBounds.forEach((element, indx) => {
        let x = element.x;
        if (indx !== 0) {
          x = newBounds[indx - 1].x - bounds[indx - 1].width;
        }
        element.x = x;
      });
    }
    return newBounds;
  }

  checkOutOfBounds() {
    //If car is moving to the right
    if (this.dir === 1) {
      if (this.position.x - this.width / 2 - 25 > GAME_ROAD_WIDTH) {
        this.position.x = -this.width / 2 - this.game.rnd.integerInRange(5, 40);
        this.chooseRandomDasher();
      }
      //If the car is moving to the left
    } else {
      if (this.position.x + this.width / 2 - 25 < 0) {
        this.position.x = GAME_ROAD_WIDTH * 1.25 + this.width / 2 + this.game.rnd.integerInRange(5, 40);
        this.chooseRandomDasher();
      }
    }
  }

  destroy() {
    super.destroy();
  }
}
